export default __webpack_public_path__ + "static/media/IFW_SoftwareCHARTS-04.41973251.png";